/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/require-default-props */
import React from 'react';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';
import SignIn from '../pages/SignIn';

import LayoutAdm from '../pages/_Layouts';
import { useCan } from '../hooks/useCan';
// import LayoutUser from '../pages/_Layouts/user';
// @ts-ignore
interface RouteProps extends ReactDOMRouteProps {
  isUser?: boolean;
  isGlobal?: boolean;
  component: React.ComponentType;
  requirePermission?: string;
}

const Route: React.FC<RouteProps> = ({
  isGlobal = false,
  requirePermission,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();
  // if() {

  // }
  const userCanAccessRoutes = useCan({
    permissions: [requirePermission || 'access_full'],
  });

  if (isGlobal) {
    return (
      <ReactDOMRoute
        {...rest}
        render={() => {
          return <Component />;
        }}
      />
    );
  }

  if (user) {
    return (
      <ReactDOMRoute
        {...rest}
        render={({ location }) => {
          return userCanAccessRoutes === !!user ? (
            <LayoutAdm path={location.pathname}>
              {/* @ts-ignore */}

              <Component />
            </LayoutAdm>
          ) : (
            <Redirect
              to={{
                pathname: '/menu',
                state: { from: location },
              }}
            />
          );
        }}
      />
    );
  }

  console.log('chegou aq');
  return <ReactDOMRoute {...rest} path="/" exact component={SignIn} />;
  // );

  // if (user) {
  //   switch (user.tag) {
  //     case 'admin': {
  //       return (
  //         <ReactDOMRoute
  //           {...rest}
  //           render={({ location }) => {
  //             return isPrivate === !!user && isAdmin ? (
  //               <LayoutAdm path={location.pathname}>
  //                 <Component />
  //               </LayoutAdm>
  //             ) : (
  //               <Redirect
  //                 to={{
  //                   pathname: isPrivate ? '/' : '/admin',
  //                   state: { from: location },
  //                 }}
  //               />
  //             );
  //           }}
  //         />
  //       );
  //     }

  //     case 'user': {
  //       return (
  //         <ReactDOMRoute
  //           {...rest}
  //           render={({ location }) => {
  //             return isPrivate === !!user && isUser ? (
  //               <LayoutUser path={location.pathname}>
  //                 <Component />
  //               </LayoutUser>
  //             ) : (
  //               <Redirect
  //                 to={{
  //                   pathname: isPrivate ? '/' : '/user',
  //                   state: { from: location },
  //                 }}
  //               />
  //             );
  //           }}
  //         />
  //       );
  //     }

  //     default:
  //       return isGlobal ? (
  //         <ReactDOMRoute
  //           {...rest}
  //           path="/painel-satisfaction-survey/:analyticId?"
  //           component={PainelSatisfactionSurvey}
  //         />
  //       ) : (
  //         <ReactDOMRoute {...rest} path="/" exact component={SignIn} />
  //       );
  //   }
  // }
  // return isGlobal ? (
  //   <ReactDOMRoute
  //     {...rest}
  //     path="/painel-satisfaction-survey/:analyticId?"
  //     component={PainelSatisfactionSurvey}
  //   />
  // ) : (
  //   <ReactDOMRoute {...rest} path="/" exact component={SignIn} />
  // );
};

export default Route;
